var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLivi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 155,
    viewBox: "0 0 227 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 227,
    height: 155,
    fill: "url(#paint0_linear_858:20)",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.275 37.4145C220.593 37.4145 227 31.332 227 22.4995C227 13.6669 220.593 7.44 211.275 7.44C201.956 7.44 195.55 13.6669 195.55 22.4995C195.55 31.332 201.955 37.4145 211.275 37.4145Z",
    fill: "#002845"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.252 44.9437H197.296V123.137H225.252V44.9437Z",
    fill: "#002845"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.058 95.6012L125.512 44.9437H95.5178L126.386 123.137H133.52H152.595H159.147L190.015 44.9437H160.604L143.058 95.6012Z",
    fill: "#002845"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2598 7.44C64.9401 7.44 58.5333 13.6669 58.5333 22.4995C58.5333 31.332 64.9401 37.4145 74.2598 37.4145C83.5794 37.4145 89.985 31.332 89.985 22.4995C89.985 13.6669 83.5782 7.44 74.2598 7.44Z",
    fill: "#002845"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2373 44.9437H60.2806V123.137H88.2373V44.9437Z",
    fill: "#002845"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9566 83.4606V15.9836H0V84.1851C0 112.422 11.066 124.44 37.1298 124.44C41.4823 124.444 45.8238 124.007 50.0873 123.137V96.6378C47.3511 97.7057 44.4355 98.2456 41.4961 98.2288C27.9566 98.2312 27.9566 87.9497 27.9566 83.4606Z",
    fill: "#002845"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_858:20",
    x1: 113.5,
    y1: 0,
    x2: 113.5,
    y2: 155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLivi);
export default __webpack_public_path__ + "static/media/logo-livi.a416225c9caaeef83a8c427dcbf2405e.svg";
export { ForwardRef as ReactComponent };